module.exports = __webpack_public_path__ + "static/media/slider-gif3.bf722601.gif";